import { render, staticRenderFns } from "./DrieLuik.vue?vue&type=template&id=81f3d8ce&scoped=true"
import script from "./DrieLuik.vue?vue&type=script&lang=js"
export * from "./DrieLuik.vue?vue&type=script&lang=js"
import style0 from "./DrieLuik.vue?vue&type=style&index=0&id=81f3d8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f3d8ce",
  null
  
)

export default component.exports